module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 166.39f31b53.png";